export const API_BASE_URL = import.meta.env.VITE_GRAPHQL_ENDPOINT || 'http://localhost:9001/graphql';
export const OCEAN_API_URL = import.meta.env.VITE_OCEAN_API_URL || 'http://localhost:8000';
export const WS_ENDPOINT = import.meta.env.VITE_GRAPHQL_WS_ENDPOINT || 'ws://localhost:9001/graphql';
export const APP_NAME = import.meta.env.VITE_APP_NAME || 'TviklaX';
export const CURRENCY = import.meta.env.VITE_CURRENCY || 'INR';
